import React from 'react';
import { useGlobalContext } from "../context/GlobalContext";


export const Header = () => {
  const { isNested,
    isLightTheme,
    menuOpen,
    setMenuOpen } = useGlobalContext()


  function menuToggle() {
    setMenuOpen(!menuOpen);

    if (document.body.classList.contains('menu-open')) {
      document.body.classList.remove('menu-open');
    } else {
      document.body.classList.add('menu-open');
    }
  }


  const links = !isNested ? (
    isLightTheme ? (
      <div className="l-header__logo-wrap">
        <a className="l-header__logo" href="https://github.com/kozlowskam" target="_blank" rel="noopener noreferrer"><img className="l-header__logo-img" src={require('../static/images/github_logo-black.png')} alt="github logo" /></a>
        <a className="l-header__logo" href="https://www.linkedin.com/in/kozlowska-m/" target="_blank" rel="noopener noreferrer"><img className="l-header__logo-img" src={require('../static/images/linkedin_logo-black.png')} alt="linkedin logo" /></a>
        <a className="l-header__logo" href="https://www.behance.net/mahorata" target="_blank" rel="noopener noreferrer"><img className="l-header__logo-img" src={require('../static/images/behance-logo.png')} alt="behance logo" /></a>
      </div>
    ) : (
        <div className="l-header__logo-wrap">
          <a className="l-header__logo" href="https://github.com/kozlowskam" target="_blank" rel="noopener noreferrer"><img className="l-header__logo-img" src={require('../static/images/github_logo.png')} alt="github logo" /></a>
          <a className="l-header__logo" href="https://www.linkedin.com/in/kozlowska-m/" target="_blank" rel="noopener noreferrer"><img className="l-header__logo-img" src={require('../static/images/linkedin_logo.png')} alt="linkedin logo" /></a>
        </div>
      )
  ) : null

  const whiteBgClass = isLightTheme ? ' is-white-bg' : '';
  const isNestedClass = isNested ? ' is-nested' : '';


  return (
    <div id="header" className={`l-header${whiteBgClass}`}>
      <div className={`l-header__wrap l-container ${isNestedClass}`}>
        {links}
        <div className="l-header__menu-tag"
          onClick={() => menuToggle()}>
          <div className="l-header__menu-title">
            MENU
          </div>
          <ul className="buns">
            <li className="bun"></li>
            <li className="bun"></li>
          </ul>
        </div>
      </div>
    </div>
  )
}